module.exports = __webpack_public_path__ + "images/mobile-app-design.7dd1a2cf8cf7ef6903d5e1b4fd0f0f15.svg";